class superCalculationHelper {
    
    calculateSuperWithInclude = (fee, percentage)  => {
        return (parseFloat(fee) - parseFloat(this.calculateFeeWithoutSuperWithInclude(fee, percentage))).toFixed(2)
    }
    calculateFeeWithoutSuperWithInclude = (fee, percentage) => {
        
        var result = parseFloat(fee) / ((parseFloat(percentage)+100)/100)
        return result.toFixed(2)
    }
    calculateSuperWithExclude = (fee, percentage)  => {
        return parseFloat(parseFloat(percentage)/100 * parseFloat(fee)).toFixed(2)
    }

}

export default new superCalculationHelper();